import type { ParsedArgs } from "@/lib/parsed/parsed-args";
import { followSession } from "@/lib/session/follow-session";
import { writeFollowedSessionOutcome } from "@/lib/session/write-followed-session-outcome";

export async function followSessionLogs(
  parsed: ParsedArgs,
  sessionId: string,
  after: number | undefined,
  asJson: boolean,
): Promise<void> {
  // JSON mode suppresses the transcript so stdout remains one document.
  const session = await followSession(sessionId, {
    quiet: asJson || parsed.booleans.has("quiet"),
    ...(after !== undefined ? { after } : {}),
  });
  writeFollowedSessionOutcome(session, asJson);
}
